
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade encryption and secure protocols to protect user data and ensure complete privacy across all connections and activities.',
      gradient: 'from-blue-400 to-blue-600'
    },
    {
      icon: 'ri-speed-line',
      title: 'High Performance',
      description: 'Optimized code and efficient algorithms deliver fast, responsive applications that enhance device performance without compromising functionality.',
      gradient: 'from-purple-400 to-purple-600'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'User-Friendly Design',
      description: 'Intuitive interfaces designed with user experience in mind, making complex security and optimization features accessible to everyone.',
      gradient: 'from-teal-400 to-teal-600'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and feature additions to ensure compatibility with the latest iOS versions and emerging security standards.',
      gradient: 'from-emerald-400 to-emerald-600'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Dedicated Support',
      description: 'Professional customer support team ready to assist users with any questions or issues, ensuring smooth and reliable app experience.',
      gradient: 'from-cyan-400 to-cyan-600'
    },
    {
      icon: 'ri-lock-line',
      title: 'Privacy First',
      description: 'No-logs policy and transparent data practices ensure that user privacy is always protected and personal information remains secure.',
      gradient: 'from-indigo-400 to-indigo-600'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Why Choose Our Products</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our applications are built with cutting-edge technology and user-centric design principles
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-10 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
